import { Injectable, inject } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { Auth0ClientService } from '@auth0/auth0-angular';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SignalrService {
  private auth0Service = inject(Auth0ClientService);
  private hubConnection!: HubConnection;
  public data: any;

  constructor() { }

  startConnection(hubUrl: string, auth0Id: string) {
    this.hubConnection = new HubConnectionBuilder()
      .configureLogging(signalR.LogLevel.Information)
      .withUrl(hubUrl, {
        accessTokenFactory: () => this.auth0Service.getTokenSilently()
      })
      .withAutomaticReconnect()
      .build();

    this.hubConnection
      .start()
      .then(() => {
        if (!environment.production) {
          console.log(`SignalR connected - connectionId: ${this.hubConnection.connectionId}`);
        } else {
          console.log(`SignalR connected`);
        }
      })
      .then(() => this.joinHubGroup(auth0Id))
      .catch(err => { 
        console.log(`SignalR connection error: ${err}`) 
      });
  }

  public getListnerConnection(listener: string): Observable<any> {
    return new Observable<any>(observer => {
      this.hubConnection.on(listener, (...data) => {
        if (data.length === 1) {
          observer.next(data[0]);
        } else {
          observer.next(data);
        }
      });

      return () => {
        this.hubConnection.off(listener);
      };
    });
  }

  private joinHubGroup(auth0Id: string) {
    this.hubConnection.invoke("JoinGroup", this.hubConnection.connectionId, auth0Id)
      .then(() => {
        if (!environment.production) {
          console.log(`User ${auth0Id} joined group ${this.hubConnection.connectionId}`);
        } else {
          console.log(`User joined group`);
        }
      });
  }

  public isConnected(): boolean {
    return this.hubConnection && this.hubConnection.state === signalR.HubConnectionState.Connected;
  }
}
